import React from 'react';
import { PhoneCall, Hourglass, TrendingDown, Sparkles } from 'lucide-react';

const PAINS = [
  {
    icon: PhoneCall,
    title: 'You accept the first carrier who says yes',
    body:
      'When a load needs to move, your team picks the first available carrier — not the best one. Every order leaves money on the table.',
  },
  {
    icon: Hourglass,
    title: 'Tendering eats your team’s day',
    body:
      'Phone calls, emails, spreadsheets. A single tender takes 10–20 minutes of back-and-forth before a truck is even booked.',
  },
  {
    icon: TrendingDown,
    title: 'No real-time view of bids vs. the market',
    body:
      'Without competing quotes next to current lane market rates, your team can’t tell in the moment whether an incoming bid is fair — or hundreds of dollars high.',
  },
];

export default function Problem() {
  return (
    <section className="bg-white">
      <div className="container-page py-20 lg:py-28">
        <div className="max-w-3xl">
          <p className="eyebrow">The problem</p>
          <h2 className="mt-3 h-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-balance">
            Manual carrier sourcing quietly drains your freight budget.
          </h2>
          <p className="mt-5 text-lg text-ink-600 text-balance">
            Most shippers don’t lose on one big mistake. They lose it load by
            load — when manual tendering means no real-time view of bids vs.
            market, and the first carrier who answers wins by default.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {PAINS.map((p) => (
            <div key={p.title} className="card-surface p-6">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-ink-100 text-ink-900">
                <p.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-5 text-base font-semibold text-ink-900">
                {p.title}
              </h3>
              <p className="mt-2 text-sm text-ink-600 leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 card-surface px-6 py-5 flex items-center gap-4 bg-ink-50">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-ink-900 text-white shrink-0">
            <Sparkles className="h-5 w-5" />
          </span>
          <p className="text-sm sm:text-base text-ink-700">
            <span className="font-semibold text-ink-900">Vibe Engine fixes this.</span>{' '}
            Configure how you want loads tendered — and let the platform run
            the auction, pick the winner, and book the truck for you.
          </p>
        </div>
      </div>
    </section>
  );
}
